const deDE= {
    login: {
      title: 'Anmelden',
      sign_in_btn: 'Anmelden'
    },
    bar: {
        logout: 'Abmelden',
        languages: 'Sprachen',
        settings: 'Einstellungen öffnen'
    },
    language: {
      name: 'Deutsch (DE)',
    },
    attributePage: {
        title: 'Attributänderungen',
        viewChanges: 'Änderungen anzeigen',
        dateTime: 'Datum',
        notificationType: 'Benachrichtigungsart',
        notificationValue: 'Benachrichtigungswert',
        oldValue: 'Alter Wert',
        newValue: 'Neuer Wert',
        accept: 'Annehmen',
        reject: 'Ablehnen',
    },
    Home: 'Home',
    load: 'Erster Ladevorgang wird ausgeführt...',
    Requested: "Angefordert",
    Viewed: "Angezeigt",
    Executing: "Wird ausgeführt",
    Completed: "Abgeschlossen",
    Expired: "Abgelaufen",
    Cancelled: "Abgebrochen",
    Error: "Fehler",
    Rejected: "Abgelehnt",
    error: 'Es ist ein Fehler aufgetreten; bitte versuchen Sie es später erneut.',
    displayname: 'Anzeigename',
    givenname: 'Vorname',
    surname: 'Nachname',
    email: 'E-Mail',
    mail: 'E-Mail',
    name: 'Vorname',
    firstname: 'Vorname',
    lastname: 'Nachname',
    footer_copyright: 'Alle Rechte vorbehalten.'
  };
  
  export default deDE;
  